export const round = (number) => {
  return Math.round(number * 1000) / 1000;
}

/**
 * @param {string | number | bigint} number 
 * @param {{
 *  minimumFractionDigits: number, 
 *  maximumFractionDigits: number,
 *  useGrouping: boolean
 * }} options
 * @returns {string}
 */
export const formatNumber = (number, options = {},) => {
  if (number == null) {
    return '';
  }

  let numberOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }

  if (Math.trunc(number) === number) {
    // for digits that don't include decimals
    numberOptions.minimumFractionDigits = 0;
    numberOptions.maximumFractionDigits = 0;
  }

  numberOptions = {
    ...numberOptions,
    useGrouping: false,
    ...options
  };

  return (
    Intl.NumberFormat(
      'en-US',
      numberOptions,
    ).format(number)
  );
}

export const formattedAmount = (amount) => {
  const formattedNumber = formatNumber(amount ?? 0, {
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return `$${formattedNumber}`;
}
